import { defineRouting } from 'next-intl/routing';
import { i18n } from './config';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: i18n.locales.map((locale) => locale.id),

  // Used when no locale matches
  defaultLocale: i18n.defaultLocale,

  domains: i18n.locales.map((locale) => ({
    domain: locale.domain,
    locales: [locale.id],
    defaultLocale: locale.id
  })),

  localePrefix: 'never'
});
